import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const LIBRARY_STAFF_USERS_ADMIN = gql`
  query LibraryStaffUsersAdmin($filter: UsersFilter, $sort: UsersSort) {
    users(filter: $filter, sort: $sort) {
      count
      data {
        id
        firstName
        lastName
        userNumber
      }
    }
  }
`;
